import React, { memo } from 'react';
import PropTypes from 'prop-types';

/**
 * BatchFormContainer - Wrapper component providing consistent styling for batch forms
 * Memoized to prevent unnecessary re-renders when children haven't changed
 * @param {React.ReactNode} children - Form content to render
 */
const BatchFormContainerComponent = ({ children }) => {
  return (
    <div className="edit-container p-4">
      {children}
    </div>
  );
};

BatchFormContainerComponent.propTypes = {
  children: PropTypes.node.isRequired
};

export const BatchFormContainer = memo(BatchFormContainerComponent);
